import React, { useEffect, useState } from 'react';
import "./Landing.css"
import BlurColor from '../../Components/BlurColor/BlurColor';
import AppInfo from '../../Utils/AppInfo';
import { FaApple, FaGooglePlay, } from "react-icons/fa";
import cross from './cross_transparent.png';
import HalfViews from './z_HalfViews/HalfViews';
import PeaColonyWeb from '../../Hung/PeaColonyWeb/PeaColonyWeb';

export const appleUrl = 'https://apps.apple.com/us/app/peacolony/id6742568449';
export const androidUrl = 'https://play.google.com/store/apps/details?id=com.colonynative';

// https://apps.apple.com/app/id6742568449

const Landing = () => {
  const { isDesktop, isTablet, isMobile, width } = useScreenWidth();

  return (
    <div className='landing-view'>
      <div style={{
        position: 'fixed',
        top: 40,
        left: "50%",
        transform: "translateX(-50%)",
        padding: 8,
        paddingTop: 8,
        paddingBottom: 8,
        borderRadius: 80,
        backgroundColor: "white",
        zIndex: 1000000,
      }}>
        {/* <FooterIconSmall/> */}
        <div style={{
          width: isMobile ? 30 : 30,
          height: isMobile ? 30 : 30,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          background: `url(${require('./RoundedLogo-min.png')})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor: "transparent",
        }}/>
      </div>
        <div className='landing-content'>
            <div className='initial-content full-page' style={{
              background: `linear-gradient(30deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.75)), url(${require('./ContnetBKG_For_Screenshots.png')})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              height: '100vh',
              width: '100vw',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              filter: 'blur(0px)',
            }}>
                <BlurColor count={50} blur={50} zIndex={0}/>
                <link href="https://fonts.googleapis.com/css2?family=Playwrite+IT+Moderna:wght@100..400&family=Satisfy&display=swap" rel="stylesheet"/>
                <div className='initial-content-container' style={{ zIndex: 2, backdropFilter: 'blur(2.5px)' }}>
                  {/*  */}
                  {/*  */}
                  {/*  */}
                  <div style={{ display: "flex", flexDirection: 'row' , justifyContent: "center", alignItems: "center", }}>
                    <div style={{
                      backgroundColor: "black",
                      fontWeight: "bold",
                      width: 100,
                      height: 100,
                      borderRadius: 80,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}>
                      <label style={
                        {
                          fontFamily:  "Satisfy",
                          color: "white",
                          fontSize: 60,
                        }
                      }>Pea</label>
                    </div>
                    <label style={
                        {
                          fontFamily:  "Satisfy",
                          color: "black",
                          fontSize: 60,
                          fontWeight: "bold",
                        }
                      }>Colony</label>
                  </div>
                  {/*  */}
                  {/*  */}
                  {/*  */}
                  <h2 className='tag-line'>{ AppInfo.tagLine }</h2>
                  <h2 className='app-description'>{ AppInfo.description }</h2>
                  <div className='authentication-buttons'
                    style={{
                      display: 'flex',
                      flexDirection: isMobile? "column" : 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 30,
                      marginTop: "24px",
                    }}
                  >
                    <AppStoreButton size='large' color='black' onClick={() => window.open(appleUrl, '_blank')} backgroundColor='white'/>
                    <PlayStoreButton size='large' color='black' onClick={() => window.open(androidUrl, '_blank')} backgroundColor='white' />
                  </div>
                </div>
            </div>
            {/*  */}
            {/*  */}

            {/*  */}
            {/*  */}
            <div className='purpose-content' style={{ justifyContent: 'center', alignItems: 'center', }}>
              <HalfViews 
                backgroundColor='#4DA8DA'
                imageLeft={true}
                imageStrings={[
                  require('../../Assets/1.png'),
                  require('../../Assets/2.png'),
                ]}
                imageAlt='PeaColony App Screenshot'
                title='Enjoy, Share, And Get Inspired By Great Content.'
                description={`Find content that inspires you, makes you laugh, or just makes your day better. We have a wide range of content from all the categories you love, including memes, art, photography, and more. Share your own content and get feedback from the community.`}
                isMobile={isMobile}
              />

              <HalfViews 
                backgroundColor='#80D8C3'
                imageLeft={false}
                imageStrings={[
                  require('../../Assets/3.png'),
                  require('../../Assets/4.png'),
                ]}
                imageAlt='PeaColony App Screenshot'
                title='Collaboratively Create Vision Boards And Group Content'
                description={`
                  <ul>
                    <li>
                      Create vision boards with your friends and family.
                    </li>
                    <li>
                      Collaboratively create content that inspires you.
                    </li>
                    <li>
                      Share your vision boards with the community and get feedback.
                    </li>
                  </ul>
                `}
                isMobile={isMobile}
                showGrid
              />

              <HalfViews 
                backgroundColor='#FFD66B'
                imageLeft={true}
                imageStrings={[
                  require('../../Assets/Colony1.png'),
                  require('../../Assets/Colony2.png'),
                ]}
                imageAlt='PeaColony App Screenshot'
                title={'<div style="margin-top: -24px; margin-bottom: 16px; opacity: 0.5;"> Finally, people with your passions...</div> <div>Create or join a village based on traits & interests that matter to you.</div>'}
                description={`
                  <ul <div style="margin-top: -16px;">
                    <li>
                    Group chats with up to <b style="color:var(--blue-100); text-decoration: underline;">2000</b> members
                    </li>

                    <li>
                      Share your thoughts, ideas, and projects
                    </li>

                    <li>
                      Hangout in the medium that fits you
                    </li>

                    <li>
                      Form very longterm friendships
                    </li>

                    <li>
                      Vote for who governs & moderates the rules of your colony.
                    </li>
                  <ul>
                `}
                isMobile={isMobile}
              />


              <HalfViews 
                backgroundColor='#FF6363'
                imageLeft={false}
                imageStrings={[
                  require('../../Assets/Story.png'),
                  require('../../Assets/ChatThread.png'),
                  require('../../Assets/AudioChatsPolls.png'),
                ]}
                imageAlt='PeaColony App Screenshot'
                title='Keep up with & get to know people that you would love in the medium that works best you...'
                description={`
                  <ul>
                    <li>
                     Stories
                    </li>

                    <li>
                      Chat Threads
                    </li>

                    <li>
                      Audio Chats
                    </li>

                    <li>
                      Polls
                    </li>

                    <li>
                      Events And News Items
                    </li>
                  <ul>
                `}
                isMobile={isMobile}
                showGrid
              />





                {/* <div style={{
                  position: 'relative',
                  width: '100%',
                  height: "90vh",
                }}>
                  <PeaColonyWeb/>
                </div> */}




              <HalfViews 
                backgroundColor='#F5F5F5'
                imageLeft={true}
                imageStrings={[
                  require('../../Assets/Final1.png'),
                  require('../../Assets/Final2.png'),
                ]}
                imageAlt='PeaColony App Screenshot'
                title={
                `
                Get Inspired By Great Content & Great People By...
                <br/>
                <h1 style="color:var(--blue-100);">Downloading PeaColony Now!<h1>
                `
                }
                description={``}
                isMobile={isMobile}
                gradient={{ top: 'rgb(245, 245, 245, 0.5)', bottom: 'white' }}
              />

            </div>
            {/*  */}
            {/*  */}
            <Footer/>
            <div style={{position: 'relative', height: 200, width: '100vw' }}></div>

        </div>
    </div>
  );
}

export default Landing;

const FooterIcon = () => {
  return (
    <div style={{ display: "flex", flexDirection: 'row' , justifyContent: "center", alignItems: "center" }}>
      <div style={{
        backgroundColor: "black",
        fontWeight: "bold",
        width: 44,
        height: 44,
        borderRadius: 80,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <label style={
          {
            fontFamily: "Satisfy",
            color: "white",
            fontSize: 22,
          }
        }>Pea</label>
      </div>
      <label style={
          {
            fontFamily: "Satisfy",
            color: "black",
            fontSize: 22,
            fontWeight: "bold",
          }
        }>Colony</label>
    </div>
  );
}


export const FooterIconSmall = () => {
  return (
    <a style={{ display: "flex", flexDirection: 'row' , justifyContent: "center", alignItems: "center", textDecoration: 'none' }} href='/'>
      <div style={{
        backgroundColor: "black",
        fontWeight: "bold",
        width: 32,
        height: 32,
        borderRadius: 60,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <label style={
          {
            fontFamily: "Satisfy",
            color: "white",
            fontSize: 16,
          }
        }>Pea</label>
      </div>
      <label style={
          {
            fontFamily: "Satisfy",
            color: "black",
            fontSize: 16,
            fontWeight: "bold",
          }
        }>Colony</label>
    </a>
  );
}



// Custom Apple SVG icon component
const sizeStyles = {
  extraSmall: { height: '32px', padding: '0 12px', iconSize: 16, topText: '8px', bottomText: '12px' },
  small: { height: '40px', padding: '0 16px', iconSize: 20, topText: '10px', bottomText: '14px' },
  medium: { height: '48px', padding: '0 20px', iconSize: 24, topText: '12px', bottomText: '16px' },
  large: { height: '56px', padding: '0 24px', iconSize: 28, topText: '14px', bottomText: '18px' },
  extraLarge: { height: '64px', padding: '0 28px', iconSize: 32, topText: '16px', bottomText: '20px' }
};

const styles = `
  .store-button {
    display: flex;
    align-items: center;
    border-radius: 8px;
    background: black;
    border: none;
    cursor: pointer;
    transition: opacity 0.2s;
  }

  .store-button:hover {
    opacity: 0.9;
  }

  .store-button__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 8px;
  }

  .store-button__top-text {
    line-height: 1;
    font-weight: normal;
  }

  .store-button__bottom-text {
    line-height: 1;
    font-weight: 600;
  }
`;

type SizeType = 'extraSmall' | 'small' | 'medium' | 'large' | 'extraLarge';

interface StoreButtonProps {
  size?: SizeType;
  color?: string;
  className?: string;
  shadow?: boolean;
  onClick?: () => void;
  backgroundColor?: string;
  border?: boolean;
  borderColor?: string;
  borderWidth?: number;
}

export const AppStoreButton = ({
  size = 'medium',
  color = 'white',
  className = '',
  shadow,
  onClick,
  backgroundColor,
  border,
  borderColor,
  borderWidth,
}: StoreButtonProps) => {
  const sizeStyle = sizeStyles[size];

  return (
    <>
      <style>{styles}</style>
      <button
        onClick={onClick}
        className={`store-button ${className} ${ shadow ? ' app-buttons' : '' }`}
        style={{ 
          height: sizeStyle.height,
          padding: sizeStyle.padding,
          color,
          backgroundColor: backgroundColor ? backgroundColor : 'rgba(255,255,255,0.8)',
          borderRadius: 16,
          backdropFilter: 'blur(20px)',
          border: border ? `${borderWidth || 1}px solid ${borderColor || 'black'}` : 'none',
        }}
      >
        <FaApple size={sizeStyle.iconSize} color={color} />
        <div className="store-button__content">
          <span 
            className="store-button__top-text"
            style={{ fontSize: sizeStyle.topText }}
          >
            Download on the
          </span>
          <span 
            className="store-button__bottom-text"
            style={{ fontSize: sizeStyle.bottomText }}
          >
            App Store
          </span>
        </div>
      </button>
    </>
  );
};

export const PlayStoreButton = ({
  size = 'medium',
  color = 'white',
  className = '',
  shadow,
  onClick,
  backgroundColor,
  border,
  borderColor,
  borderWidth,
}: StoreButtonProps) => {
  const sizeStyle = sizeStyles[size];

  return (
    <>
      <style>{styles}</style>
      <button
        onClick={onClick}
        className={`store-button ${className} ${ shadow ? ' app-buttons' : '' }`}
        style={{ 
          height: sizeStyle.height,
          padding: sizeStyle.padding,
          color,
          backgroundColor: backgroundColor ? backgroundColor : 'rgba(255,255,255,0.8)',
          borderRadius: 16,
          backdropFilter: 'blur(20px)',
          border: border ? `${borderWidth || 1}px solid ${borderColor || 'black'}` : 'none',
        }}
      >
        <FaGooglePlay size={sizeStyle.iconSize} color={color} />
        <div className="store-button__content">
          <span 
            className="store-button__top-text"
            style={{ fontSize: sizeStyle.topText }}
          >
            Get it on
          </span>
          <span 
            className="store-button__bottom-text"
            style={{ fontSize: sizeStyle.bottomText }}
          >
            Google Play
          </span>
        </div>
      </button>
    </>
  );
};


type ScreenSize = 'mobile' | 'tablet' | 'desktop';

interface ScreenWidthReturn {
  width: number;
  isDesktop: boolean;
  isTablet: boolean;
  isMobile: boolean;
  screenSize: ScreenSize;
}

export const useScreenWidth = (): ScreenWidthReturn => {
  const [width, setWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isDesktop = width >= 1024;
  const isTablet = width >= 768 && width < 1024;
  const isMobile = width < 768;

  const screenSize: ScreenSize = 
    isDesktop ? 'desktop' : 
    isTablet ? 'tablet' : 
    'mobile';

  return {
    width,
    isDesktop,
    isTablet,
    isMobile,
    screenSize
  };
};



export const Footer = () => {
  return (
    <footer className='footer' style={{

    }}>
      <FooterIcon/>
      <div className='footer-links'>
        <a href='#'><label>About</label></a>
        <a href='/privacy-policy'><label>Privacy</label></a>
        <a href='#'><label>EULA</label></a>
        <a href='/terms-of-service'><label>Terms Of Service</label></a>
        <a href='#'><label>Careers</label></a>
        <a href='/support'><label>Support</label></a>
        <a href='/delete-account-request'><label>Delete Account Request</label></a>
        <a href='/csae-standards'><label>CSAE Standards</label></a>
        <AppStoreButton size='extraSmall' color='black' onClick={() => window.open(appleUrl, '_blank')} />
        <PlayStoreButton size='extraSmall' color='black' onClick={() => window.open(androidUrl, '_blank')} />
      </div>
      {/*  */}
      <img style={{
        height: 30,
        width: 'auto',
        marginTop: 12,
        marginBottom: 12,
      }} src={ cross }/>
      <label className='company' style={{ fontSize:'12px', }}>© {AppInfo.name} 2025</label>
    </footer>
  )
};


/*
              <h3 className='purpose-content-text' dangerouslySetInnerHTML={{__html:
                `
                  <h2>${AppInfo.name} is a place for people looking to be part of a great community online.</h2>
                  </br>
                  </br>
                  - You are given a community with up to <b style="color:var(--blue-100); text-decoration: underline;">2000</b> members just like you.
                  </br>
                  - Share your thoughts, ideas, and hangout in which ever medium that fits you.
                  </br>
                  - Form very longterm friendships and relationships.
                  </br>
                  - Vote for who governs & moderates the rules of your colony.
                  `
              }}/>
*/



/*
  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: 24, marginBottom: 50 }}>
    <img src={require('./ex2.png')} style={{ width: isMobile ? 150 : 220, height: 'auto', transform: 'rotate(30deg)'}}/>
    <img src={require('./postD.png')} style={{ width: isMobile ? 150 : 220, height: 'auto', transform: 'rotate(30deg)'}}/>
    <img src={require('./AudioChat.png')} style={{ width: isMobile ? 150 : 220, height: 'auto', transform: 'rotate(30deg)'}}/>
    <img src={require('./example.png')} style={{ width: isMobile ? 150 : 220, height: 'auto', transform: 'rotate(30deg)'}}/>
    <img src={require('./post.png')} style={{ width: isMobile ? 150 : 220, height: 'auto', transform: 'rotate(30deg)'}}/>
    <img src={require('./AudioChatD.png')} style={{ width: isMobile ? 150 : 220, height: 'auto', transform: 'rotate(30deg)'}}/>
    <img src={require('./ex2.png')} style={{ width: isMobile ? 150 : 220, height: 'auto', transform: 'rotate(30deg)'}}/>
  </div>
 */